import ActivityAppState from '../apps/activities/state'
import ReportAppState from '../apps/reports/state'
import SettingsAppState from '../apps/settings/state'
import SlidewareAppState from '../apps/slideware/state'
import getStorage from '../storage/index'
import BackboneSessionHelper from '../util/backbone_session_helper'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

function resetLocalData () {
  this.set({
    settings: getStorage(this.get('user'), 'setting')
  })

  // Propagate theme change event
  this.get('settings').on('change:theme', (model, theme) => {
    this.trigger('change:theme', model, theme)
  })

  this.trigger('change:theme', this.get('settings'), this.get('settings').get('theme'))
}

/**
 * Tracks application state
 *
 * @event change:theme Theme change
 *  @property {String} name Theme name
 *
 * @event session:start User logged in and model hydrated
 *  @property {Model} user User model
 *
 * @event session:logout User logged out
 * @event session:anonymous No user on startup
 *
 */
export default class State extends Backbone.Model {
  get defaults () {
    return {
      settings: null,
      user: null,
      participant: null,
      externalScreenConnected: false
    }
  }

  get legacySession () {
    return this.backboneSessionHelper.session
  }

  initialize (attrs = {}, options = {}) {
    // Track states for apps
    this.appStates = {
      activities: new ActivityAppState({ user: attrs.user, mode: attrs.mode }),
      reporting: new ReportAppState({ user: attrs.user }),
      settings: new SettingsAppState(),
      slideware: new SlidewareAppState({ user: attrs.user })
    }

    // Session is fully loaded with user
    this.on('session:start', () => {
      resetLocalData.call(this)

      // Session started. Redirect to terms agreement if necessary
      if (store.getState()[profileSlice.name].participant?.must_consent) {
        // check whether we should show the terms page first
        store.dispatch(appSlice.pageUpdated('terms_agreement'))
      }
    })

    this.backboneSessionHelper = new BackboneSessionHelper(this).startSyncing()

    // Propagate attributes
    this.on('change:externalScreenConnected', (model, val) => {
      this.appStates.activities.set({ externalScreenConnected: val })
    })
  }

  messageHistory () {
    return getStorage(this.get('user'), 'message')
  }

  inspect () {
    const result = super.toJSON()

    // Deal with state model attributes whose values are complex types
    result.participant = this.get('participant')?.toJSON()
    result.settings = this.get('settings')?.toJSON()
    result.user = this.get('user')?.toJSON().user

    // Deal with state object properties tacked on outside of the underlying Backbone.Model
    result.appStates = {}
    Object.entries(this.appStates).forEach(([key, value]) => {
      result.appStates[key] = value.inspect()
    })

    return result
  }

  destroy () {
    this.backboneSessionHelper.stopSyncing()
  }
}
